import Modal from '@/lib/Modal';
import SuccessScreen from '@/shared/Components/SuccessScreen';

const EsignSuccess = ({
  isOpen,
  onDismiss,
}: {
  isOpen: boolean;
  onDismiss: () => void;
}): JSX.Element => {
  return (
    <Modal onDismiss={onDismiss} showClose={false} isOpen={isOpen}>
      <div className="d:flex d:justify-center">
        <SuccessScreen
          title="E-Sign successful!  🎉"
          topDescription="Taking you to complete payment"
          ctaText="Taking you to complete payment"
          ctaLoading={true}
          onCtaClick={(): void => {
            // do nothing
          }}
        />
      </div>
    </Modal>
  );
};

export default EsignSuccess;
